import React from 'react';
import RecordingManagement from '../Recordings/RecordingManagement';

const Recordings = () => {
  return <RecordingManagement />;
};

export default Recordings; 